import { useEffect, useMemo } from "react";
import ReactExport from "react-data-export-typescript"
import { DynamicFields } from "../../../utils/dynamicFields";

export const ExcelExport = ({
    rows, 
    head, 
    file, 
    title,
    columns,
}) => {
    
    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    const ButtonLink = () => {
        return (
            <div>
                {title}
            </div>
        )
    }

    const rowsDeleteSignature = useMemo(() => {
        let variable = []
        columns.map((column) => {
            if (column.typePole === DynamicFields.SIGNATURE_FOR_TABLE) {
                variable.push(column.field)
            }
        })
        let rowsMutate = [...rows]
        const cleareRow = rowsMutate.map((row) => {
            let newRow = {...row}
            variable.map((el) => {
                newRow[el] = ''
            })
            return newRow
        })

        return cleareRow

    }, [rows])

     
    return (
        <ExcelFile  
            element = {<ButtonLink />}
            filename={`${file} - ${title.toLowerCase()}`}
        >
            <ExcelSheet data={rowsDeleteSignature} name={file}>
                {
                    head.map((pole) => <ExcelColumn label={pole.label} value={pole.key} />)
                }
            </ExcelSheet>
        </ExcelFile>  
        
    );
}